import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { GET, GET_CLAIM_FULL_SEARCH } from '../../../../services';

export const useGetClaimFull = ({ handleSubmit }) => {
  const [data, setData] = useState([]);
  const { isPending, mutate: onSearchFull } = useMutation({
    mutationFn: async (searchParamState) => {
      const { search } = searchParamState;
      const response = await GET(GET_CLAIM_FULL_SEARCH({ search: search || '' }));
      return response.result.items || [];
    },
    onSuccess(response) {
      setData(response);
    },
  });
  const onFetchFull = () =>
    handleSubmit((values) => {
      return onSearchFull(values);
    })();

  return { dataSource: data, setData, onSearchFull, loading: isPending, onFetchFull };
};
